module.exports = __webpack_public_path__ + "static/media/buzz_crew_gfx_m.9a9787f2.png";